
import { BrowserModule } from "@angular/platform-browser";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { HttpClientModule } from "@angular/common/http";
import { Title } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule } from "./app-routing.module";
import { NgbModule, NgbCollapseModule, NgbProgressbarModule } from "@ng-bootstrap/ng-bootstrap";
import { ChartsModule } from 'ng2-charts';

import { UserIdleModule } from "angular-user-idle";

import { AuthService } from "./services/auth.service";
import { ServiceService } from "./services/service.service";
import { ConnectionService } from "./services/connection.service";
import { MessagingService } from "./services/messaging.service";
import { AuthInterceptor } from "./auth.interceptor";
import { AppComponent } from "./app.component";
import { TableModule } from "ngx-easy-table";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
// import { DataTableModule } from 'ng-angular8-datatable';
import { DataTablesModule } from "angular-datatables";
// import { FlatpickrModule } from 'angularx-flatpickr';
// import { CalendarModule, DateAdapter } from 'angular-calendar';
// import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
// import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';


import { SocialLoginModule, SocialAuthServiceConfig } from "angularx-social-login";
import { GoogleLoginProvider, FacebookLoginProvider } from "angularx-social-login";
import { AgmCoreModule } from '@agm/core';
import { AgmDirectionModule } from 'agm-direction';
import { DatePipe } from '@angular/common';

// import { StompService } from 'ng2-stomp-service';
import { NguiMapModule} from '@ngui/map';
import { HeaderModule } from './components/header/header.module';
import { FooterModule } from './components/footer/footer.module';
import { SidemenuModule } from './components/sidemenu/sidemenu.module';
import { SelectDropDownModule } from 'ngx-select-dropdown'
import { DataAccessService } from './components/app-modules/access-control/access-control/access-controls.service';
import { BoardComponent } from './components/board/board.component';
import { UserSecurityComponent } from './user-security/user-security.component';
import { TooltipModule } from 'ng2-tooltip-directive';
import { UserAccessComponent } from './user-access/user-access.component';
import { AuthGuardService } from './auth-guard.service';
import { LoginModule } from "./components/login/login.module";
import { DashboardModule } from "./components/app-modules/dashboard/dashboard.module";
import { ChartModule } from 'angular-highcharts';
import { InventoryTankDetailsComponent } from "./components/inventory-tank-details/inventory-tank-details.component";
import { LoadDetailsModule } from "./components/load-details/load-details.module";
import { EmergencyBolModule } from "./components/app-modules/emergency-bol/emergency-bol.module";
import { UploadModule } from "./components/app-modules/upload/upload.module";
import { DriverRouteSheetComponent } from './components/driver-route-sheet/driver-route-sheet.component';
import { BillOfLadingComponent } from './components/bill-of-lading/bill-of-lading.component';
// import { GooglemapsModule } from "./components/app-modules/googlemaps/googlemaps.module";
//Test apple.
@NgModule({
  declarations: [AppComponent, BoardComponent, UserSecurityComponent,
    UserAccessComponent, InventoryTankDetailsComponent, DriverRouteSheetComponent, BillOfLadingComponent],
  imports: [
    BrowserModule,
    // NgxGoogleAnalyticsModule.forRoot('G-W7P7Q641XC'),
    // NgxGoogleAnalyticsRouterModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    NgbCollapseModule,
    FormsModule,
    TableModule,
    ReactiveFormsModule,
    HttpClientModule,
    SocialLoginModule,
    ChartsModule,
    ChartModule,
    HeaderModule,
    FooterModule,
    SidemenuModule,
    LoginModule,
    LoadDetailsModule,
    // GooglemapsModule,
    // DataTableModule,
    DataTablesModule,
    DashboardModule,
    SelectDropDownModule,
    EmergencyBolModule,
    UploadModule,
    // NgbModalModule,
    // FlatpickrModule.forRoot(),
    // CalendarModule.forRoot({
    //   provide: DateAdapter,
    //   useFactory: adapterFactory
    // }),
    NgbModule,
    NguiMapModule.forRoot({apiUrl: 'https://maps.google.com/maps/api/js?key=AIzaSyBTMaIvfE0gvOAGXT_T1IFJbBAwqb78syA'}),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBTMaIvfE0gvOAGXT_T1IFJbBAwqb78syA'
      /* apiKey is required, unless you are a
      premium customer, in which case you can
      use clientId
      */
    }),
    AgmDirectionModule,
    TooltipModule,
    //HttpModule,
    UserIdleModule.forRoot({ idle: 600, timeout: 1200, ping: 120 })
  ],
  schemas:[CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    Title,
    ConnectionService,
    MessagingService,
    AuthService,
    ServiceService,
    DataAccessService,
    AuthGuardService,
    // StompService,
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
  ],
  bootstrap: [AppComponent],
  exports: [ChartsModule]
})
export class AppModule {}
